import React from "react";
// import PropTypes from 'prop-types'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import {
  primaryColor,
  secondaryColor,
  tercaryColor,
  bodyColor,
  bodyBgColor,
  buttonBgColor,
  bodyAltColor,
} from "helpers/colors";
export default class Theme extends React.Component {
  render() {
    const { children } = this.props;
    const theme = createMuiTheme({
      palette: {
        type: "dark",
        // tonalOffset: 1,
        // contrastThreshold: 1,
        primary: {
          main: primaryColor,
          secondary: "#ff0000",
          dark: primaryColor,
          contrastText: "#fff",
          green: secondaryColor,
        },
        secondary: {
          // main: primaryColor,
          main: primaryColor,
          alt: secondaryColor,
          light: "#fff",
          dark: "#fff",
          contrastText: "#fff",
        },
        tercary: {
          main: tercaryColor,
        },
        text: {
          primary: bodyColor,
          // disabled: bodyColor,
          secondary: "#fff",
        },
        action: {
          disabled: "#ccc",
        },
        background: {
          default: bodyBgColor,
          // paper: "#fff",
          // paper: "#292953",
          paper: bodyBgColor,
          // input: "#fff",
        },
        // action: {
        //   hover: "#ff0000",
        // },
        // action: {
        //   active: '#ff0000',
        //   selected: '#ff0000',
        //   hover: '#ff0000',
        // }
        replays: {
          breadCrumbColor: '#fff',
          backgroundColor: 'transparent',
        },

      },
      typography: {
        fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
        fontSize: 12,
        useNextVariants: true,
        h1: {
          padding: "10px 30px",
          fontSize: "20px",
          color: "#fff",
          fontWeight: 700,
          backgroundColor: "transparent",
          color: "#004b7f",
          fontSize: "3rem",
          textTransform: "uppercase",
        },
        h2: {
          color: primaryColor,
          letterSpacing: "0.39px",
          fontSize: "26px",
        },
        h3: {
          color: secondaryColor,
          fontSize: "30px",
          fontWeight: "bold",
          lineHeight: "47px",
          // border: "1px " + bodyColor + " solid",
          // paddingTop: 5,
          // paddingBottom: 5,
          paddingLeft: 10,
          paddingRight: 10,
        },
        h4: {
          // color: primaryColor,
          color: "#fff",
          fontSize: "24px",
          // lineHeight: "40px",
          lineHeight: "28px",
          textAlign: "center",
          // border: "1px " + bodyColor + " solid",
          // paddingTop: 5,
          // paddingBottom: 5,
        },
        h5: {
          fontSize: "1.6rem",
          lineHeight: "1.43",
          color: bodyColor,
          // border: "1px " + bodyColor + " solid",
          // paddingTop: 5,
          // paddingBottom: 5,
          textTransform: "uppercase",
          fontWeight: 700,
        },
        h6: {
          lineHeight: "1.43",
          color: bodyColor,
          // border: "1px " + bodyColor + " solid",
          paddingLeft: 16,
          paddingRight: 16,
          "& a": {
            color: "inherit",
            textDecoration: "underline",
          },
          // paddingTop: 5,
          // paddingBottom: 5,
        },
        body1: {
          color: bodyColor,
          "& a": {
            color: "inherit",
            textDecoration: "underline",
          },
        },
        body2: {
          color: "#fff",
          fontSize: "0.9rem",
          "& a": {
            color: "inherit",
            textDecoration: "underline",
          },
          // fontSize: "14px",
          // fontWeight: 500,
          // letterSpacing: "0.5px",
          // lineHeight: "29px",
        },
        subtitle1: {
          letterSpacing: "2px",
          fontSize: "14px",
        },
        caption: {
          fontSize: "12px",
          letterSpacing: "0.43px",
          fontStyle: "italic",
        },
        subtitle2: {
          textTransform: "uppercase",
          color: "#009EE3",
          letterSpacing: "1.17px",
          fontSize: "14px",
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
        // MuiPaper: {
        //   root: {
        //     backgroundColor: "#fff",
        //     color: "#000",
        //   },
        // },
        MuiTypography: {
          colorPrimary: {
            borderColor: primaryColor,
          },
        },
        MuiButton: {
          outlinedPrimary: {
            color: "#fff",
          },
          outlinedSecondary: {
            color: "#fff",
          },
          root: {
            // color: primaryColor, // Some CSS
            // backgroundColor: '#d2d2d2'
            color: "#fff", // Some CSS
            backgroundColor: buttonBgColor,
            border: "1px transparent solid",
            padding: "8px 20px",
            boxShadow:
              "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)",
            "& .MuiButton-label": {
              padding: "3px 15px",
            },
            // '&.outlinedPrimary': {
            //   color: '#fff',
            // },
            // '&.outlinedSecondary': {
            //   color: '#fff',
            // },
            "&:hover": {
              backgroundColor: "#fff",
              border: "1px " + bodyColor + " solid",
              color: primaryColor,
            },
            "&.MuiButton-sizeLarge": {
              padding: "8px 20px",
              // paddingLeft: 50,
              // paddingRight: 50
            },
            // '&.MuiButton-testSizeLarge': {
            //   paddingLeft: 50,
            //   paddingRight: 50
            // },
            "&.MuiButton-textSecondary": {
              backgroundColor: "#fff",
              color: primaryColor,
              "&:hover": {
                backgroundColor: tercaryColor,
                color: "#fff",
              },
            },
          },
        },
        MuiInputBase: {
          root: { color: "#fff", borderColor: "#fff" },
        },
        MuiFormLabel: {
          root: { color: "#fff" },
        },
        "MuiButton-textSecondary": {},
        MuiFormHelperText: {
          root: {
            color: "#eee",
          },
        },
        "MuiStepper-root": {
          padding: 0,
        },
        MuiStep: {
          root: {
            "& > .MuiStepConnector-root": {
              display: "none",
            },
          },
        },
        MuiOutlinedInput: {
          notchedOutline: {
            "&:hover": {
              // borderColor: "red",
            },
          },
        },
        //             fontSize: '24px',
        //             width: 34,
        //             height: 34,
        //             marginTop: '-7px',
        //             color: 'green',
        //             border: '2px '+secondaryColor+' solid',
        //             opacity: .3,
        //             '& .MuiStepIcon-text': {
        //               color: 'blue'
        //             },
        //             '& > circle': {
        //               fill: '#fff'
        //             },
        //             '& > text': {
        //               fill: primaryColor
        //             },
        //             '&.MuiStepIcon-active': {
        //               marginTop: '-13px',
        // backgroundColor: '#fff',
        //               width: 50,
        //               height: 50,
        //               opacity: 1
        //             }
        //           }
        //         }
        // // MuiInput: {
        // //   root: {
        // //     color: primaryColor
        // //   },
        // //   outlined: {
        // //     borderRadius: '30px'
        // //   }
        // // },
        // MuiOutlinedInput: {
        //   input: {
        //     paddingLeft: 15,
        //     paddingRight: 15
        //     // textAlign: 'center'
        //   }
        // },
        // MuiPrivateNotchedOutline: {
        //   root: {
        //     borderRadius: '30px',
        //     overflow: 'hidden',
        //     textAlign: 'center'
        //   }
        // },
        // MuiPaper: {
        //   rounded: {
        //     borderRadius: '16px'
        //   }
        // }
      },
    });
    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx